import { get } from "lodash";
import { useQuery } from "react-query";

import { mapPartnersFilterToQuery } from "~/entity/Partners/lib/mapPartnersFilterToQuery";
import { mapPartnersApiToView } from "~/entity/Partners/lib/partnerMapper";
import { IPartner } from "~/entity/Partners/model/schema";
import { IPartnersFilterForm } from "~/pages/Partners/PartnersFilter";

import { usePartners } from "./usePartners";

interface UseGetPartnersListParams {
  page: number;
  count: number;
  filter: IPartnersFilterForm;
}

export const useGetPartnersList = ({
  page,
  count,
  filter,
}: UseGetPartnersListParams) => {
  const { queryKeys, getPartnersList } = usePartners();
  const queryParams = mapPartnersFilterToQuery(page, count, filter);

  const query = useQuery({
    queryKey: queryKeys.list(queryParams),
    queryFn: () => getPartnersList(queryParams),
  });

  const partners = mapPartnersApiToView(
    get(query.data, "data.partners", []),
  ) as IPartner[];

  return {
    ...query,
    partners,
  };
};
